<template>
  <div style="width: 100%; height: 100%; position: relative">
    <div :style="{width:'100%', height:height}" :id="id"></div>
    <!--    <div v-if="this.option.length" class="unit">-->
    <!--      单位：{{ this.unit }}-->
    <!--    </div>-->
    <div v-show="isNull" :style="{width:width, height:height}" class="nostr">No Data</div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'ChartBar',
  props: {
    id: {
      type: String,
      default: '' 
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    keyName: {
      type: String,
      default: ''
    },
    keyCount: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: '10 thousand CNY'
    },

    barColor: {
      type: String,
      default: '#56D457'
    },
    barBorderColor: {
      type: String,
      default: '#0DBF14'
    },

    dataZoomFlag: {
      type: Boolean,
      default: true
    },
    option: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isNull:false,
      dataZoomConfig: [
        {
          type: 'inside',
          start: 0,
          end: 40
        },
        {
          height: 17,
          type: 'slider',
          borderColor: '#fff',
          backgroundColor: '#F4F4F4',
          fillerColor: '#E0E2F5',
          dataBackground: {
            lineStyle: {
              // 线的颜色
              color: '#e0e2f5'
              // width: 3,
              // opacity: 1
            },
            areaStyle: {
              color: '#E0E2F5'
            }
          },
          handleIcon: 'path://M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z'
        }
      ]
    }
  },
  methods: {},
  watch: {
    option: {
      handler (newVal) {
        if (newVal.length) {
          // x轴
          let xData = []
          // 数据
          const data = []
          // 遍历数据

          newVal.forEach(item => {
             // 添加过滤判断
            if(this.id === 'cysss'){
              xData.push(item[this.keyName].replace('FTZ',""))
            }else{
              xData.push(item[this.keyName])
            }
            // if (!item[this.keyCount]) {
            //   data.push(0)
            // } else {
              data.push(item[this.keyCount])
            // }
            // data.push(item[this.keyCount])
          })


          // 判断是不是所有值都是空
          let arr = data
          arr = arr.find(ele => { return ele != null})
          if(arr == undefined){
            this.isNull = true
            xData = []
            //console.log('abc',"暂无数据")
          }else{
            this.isNull = false
          }
          
          const chart = echarts.init(document.getElementById(this.id))
          const option = {
            title: {},
            tooltip: {
              axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                 type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
              },
              backgroundColor: 'rgba(255,255,255,0)',
              // position: ['50%','50%'],
              trigger: 'axis',
              formatter: (params) => {
                //  如果没值 显示 暂无数据
                // console.log('如果没值 显示 暂无数据',params[0])
                if(params[0].value == null || params[0].value == undefined ){
                return `
                  <div style="position: relative;">
                      <div
                          style="background: #fff; padding: 8px 15px; border-radius: 4px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);">
                          <p style="margin: 0; color: #000; font-size: 12px;">
                             No Data
                          </p>
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div>
                  <div style="margin-top: 5px; position: relative; width: 100%; height: 18px;">
                    <div style="position: absolute; left: 50%; top: 5px; margin-left: -9px; width: 18px; height: 18px; background: #fff; border: 3px solid #FAA800; border-radius: 50%"></div>
                  </div>
                `
                }else{
                return`
                  <div style="position: relative;">
                      <div
                          style="background: #fff; padding: 8px 15px; border-radius: 4px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);">
                          <p style="margin: 0; color: #000; font-size: 14px;">${params[0].name}</p>
                          <p style="margin: 0; color: #000; font-size: 12px;">
                              ${this.title}:
                              <span style="color: #409EFF">
                                  ${params[0].value}
                              </span>
                              ${this.unit}
                          </p>
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div>
                  <div style="margin-top: 5px; position: relative; width: 100%; height: 18px;">
                    <div style="position: absolute; left: 50%; top: 5px; margin-left: -9px; width: 18px; height: 18px; background: #fff; border: 3px solid #FAA800; border-radius: 50%"></div>
                  </div>
                `
                }
              }
            },
            legend: {},
            grid: {
              left: '35px',
              right: '20px',
              top: '30px',
              bottom: this.dataZoomFlag ? '70px' : '30px',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              axisLabel: {
                rotate: 70,
                color: '#000'
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              data: xData
            },
            dataZoom: !xData.length ? false:[
              { 
                type: 'slider',  // slider 下拉条缩放  // inside 鼠标滚轮缩放
                start: 0,
                end: 40,
                height: 17,
              },
              // {
              //   height: 17,
              //   type: 'slider',
              //   borderColor: '#fff',
              //   backgroundColor: '#F4F4F4',
              //   fillerColor: '#E0E2F5',
              //   dataBackground: {
              //     lineStyle: {
              //       // 线的颜色
              //       color: '#e0e2f5'
              //       // width: 3,
              //       // opacity: 1
              //     },
              //     areaStyle: {
              //       color: '#E0E2F5'
              //     }
              //   },
              //   handleIcon: 'path://M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z'
              // }
            ],
            yAxis: {
              type: 'value',
              splitLine: {
                show: false,
                lineStyle: {
                  color: ['#EBEBEB']
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            },
            series: [
              {
                // name: 'name1',
                type: 'bar',
                data: data,
                z: 10,
                barWidth: 12,
                itemStyle: {
                  borderColor: this.barBorderColor,
                  borderWidth: 1,
                  barBorderRadius: 2,
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: this.barColor},
                      {offset: 1, color: this.barColor}
                    ]
                  )
                },
                emphasis: {
                  itemStyle: {
                    borderColor: this.barBorderColor,
                    barBorderRadius: 2,
                    borderWidth: 1,
                    color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                        {offset: 0, color: this.barColor},
                        {offset: 1, color: this.barColor}
                      ]
                    ),
                    opacity: 0.7
                  }
                }
              }
            ]
          }
          chart.setOption(option)
        }
      }
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      const chart = echarts.init(document.getElementById(this.id))
      chart.resize()
    })
  }
}
</script>

<style scoped>
.unit {
  position: absolute;
  top: 10px;
  right: 35px;
  font-size: 12px;
  color: #717982;
}
.nostr{
  position: absolute;
  top: 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
